import React from "react"
import { usePageContext } from "vike-react/usePageContext"
import AldooRouter from "aldoo-ra/Router"
import AldooPageRenderer from "aldoo-ra/AldooComponent/renderers/AldooPageRenderer"

function Page() {
  const pageContext = usePageContext()
  const urlPathname = pageContext.urlPathname

  // First check if there's a dynamic page from context (passed from SSR)
  const dynamicPage = pageContext.dynamicPage || pageContext.pageData
  if (dynamicPage) {
    return <AldooPageRenderer key={urlPathname} pageData={dynamicPage} />
  }

  // Otherwise try to resolve from AldooRouter
  const Component = AldooRouter.resolve(urlPathname)

  if (!Component) {
    // If no component found, resolve the /404 route instead
    const NotFoundComponent = AldooRouter.resolve("/404")
    if (NotFoundComponent) {
      return <NotFoundComponent key={urlPathname} pageContext={pageContext} />
    }
    // Fallback if even /404 route doesn't exist
    return <div>404 - Page not found</div>
  }

  return <Component key={urlPathname} pageContext={pageContext} />
}

export default Page